/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Bussiness types.
 */
export type CreatePaymentRequestPurposeBizType = typeof CreatePaymentRequestPurposeBizType[keyof typeof CreatePaymentRequestPurposeBizType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePaymentRequestPurposeBizType = {
  solution: 'solution',
  instruction: 'instruction',
} as const;
